import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { UserContext } from "../../../common/user/UserContext";
import { cleanJoin } from "../../../utils/stringUtil";

function LogoutIcon({ className, icon, size = 2 }) {
  const user = useContext(UserContext);

  return (
    <FontAwesomeIcon
      className={cleanJoin("is-link", className)}
      onClick={user.logout}
      size={size + "x"}
      icon={icon}
    />
  );
}

export default LogoutIcon;
